var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCombobox',_vm._g(_vm._b({attrs:{"filled":"","hide-selected":"","multiple":"","small-chips":"","outlined":"","clearable":"","single-line":""}},'VCombobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }